/**
 * @generated SignedSource<<eac1faa3a30cbe0e583ec1f8b9cf17e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ObjectGroupPositionInputTuple = {
  groupId: string;
  objectId: string;
};
export type HomeBulkMoveToOneOnOneGroupMutation$variables = {
  items?: ReadonlyArray<ObjectGroupPositionInputTuple> | null;
};
export type HomeBulkMoveToOneOnOneGroupMutation$data = {
  readonly bulkAddOrMoveToGroup: {
    readonly movedObjects: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"HomePanelGroupsMenu_object">;
    }>;
  } | null;
};
export type HomeBulkMoveToOneOnOneGroupMutation = {
  response: HomeBulkMoveToOneOnOneGroupMutation$data;
  variables: HomeBulkMoveToOneOnOneGroupMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "items"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "items",
    "variableName": "items"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HomeBulkMoveToOneOnOneGroupMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BulkAddOrMoveToGroup",
        "kind": "LinkedField",
        "name": "bulkAddOrMoveToGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "movedObjects",
            "plural": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "HomePanelGroupsMenu_object"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HomeBulkMoveToOneOnOneGroupMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BulkAddOrMoveToGroup",
        "kind": "LinkedField",
        "name": "bulkAddOrMoveToGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "movedObjects",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isHomePanelObjectInterface"
              },
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  }
                ],
                "type": "NoteStream",
                "abstractKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "HomePanelGroup",
                "kind": "LinkedField",
                "name": "homePanelGroup",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "16e47c61b60ce1ece81fe8eca6e2432e",
    "id": null,
    "metadata": {},
    "name": "HomeBulkMoveToOneOnOneGroupMutation",
    "operationKind": "mutation",
    "text": "mutation HomeBulkMoveToOneOnOneGroupMutation(\n  $items: [ObjectGroupPositionInputTuple!]\n) {\n  bulkAddOrMoveToGroup(items: $items) {\n    movedObjects {\n      __typename\n      ...HomePanelGroupsMenu_object\n      id\n    }\n  }\n}\n\nfragment HomePanelGroupsMenu_object on HomePanelObjectInterface {\n  __isHomePanelObjectInterface: __typename\n  id\n  __typename\n  ... on NoteStream {\n    type\n  }\n  homePanelGroup {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "b167816273364458ce8e9639b6cee48e";

export default node;
